import { render, staticRenderFns } from "./ClassGallery.vue?vue&type=template&id=4961b2ea&"
import script from "./ClassGallery.vue?vue&type=script&lang=js&"
export * from "./ClassGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports